module.exports = __webpack_public_path__ + "img/6.894a2ea8.png";